"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../../../Constant");

var _Flex = require("../../../Layout/Flex");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  margin-bottom: 15px;\n  margin-top: 24px;\n  border-radius: 4px;\n  position: relative;\n  flex-direction: column;\n  padding: 24px;\n  /* border is to improve experience for Windows high contrast users */\n  border: 1px solid transparent;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Card = (0, _styledComponents.default)(_Flex.FlexContainer)(_templateObject(), _Constant.Color.WHITE);
var _default = Card;
exports.default = _default;